import { c as _c } from "react/compiler-runtime";
import { useBlockExplorer } from "@opensea/app-kit";
import { CenterAligned, classNames, Flex, FlexColumn, formatAddress, NumberDisplay, Spinner, TextBody, TextHeading, TextLabel, transitions } from "@opensea/ui-kit";
import { ArrowDownward, Check, Close, Send } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { AnimatePresence, motion } from "motion/react";
import { useCallback, useState } from "react";
import { useTranslations } from "use-intl";
import { Avatar } from "../../../../components/Avatar";
import { Button } from "../../../../components/Button";
import { useScheduler } from "../../../../polychain/hooks/useScheduler";
import { FlowActions } from "../../../../stores/flowStore";
const iconClassNames = classNames("transition duration-1000 ease-out-quint");
const headingClassNames = classNames("fixed w-full text-center font-normal", "transition duration-500 ease-out-quint");
export function Sending(t0) {
  const $ = _c(100);
  const {
    actions,
    currency,
    quantity,
    ensName,
    imageUrl,
    address,
    onBack
  } = t0;
  const t = useTranslations("wallet.SendFlow");
  const [isDone, setIsDone] = useState(false);
  const [transactionHash, setTransactionHash] = useState();
  const {
    getTransactionUrl,
    getName
  } = useBlockExplorer(currency.chainIdentifier);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async lastResponse => {
      const tx = lastResponse;
      setTransactionHash(tx.transactionIdentifier.hash);
      const receipt = await tx.wait({
        confirmations: 1,
        timeout: 120000
      });
      if (receipt.status === "success") {
        FlowActions.onSuccess();
      }
      setIsDone(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== actions) {
    t2 = {
      actions,
      onAllActionsCompleted: t1,
      autoStartEmbeddedWallet: true
    };
    $[1] = actions;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    isLoading,
    isPending,
    error,
    retry
  } = useScheduler(t2);
  let t3;
  if ($[3] !== getTransactionUrl || $[4] !== transactionHash) {
    t3 = transactionHash ? getTransactionUrl(transactionHash) : undefined;
    $[3] = getTransactionUrl;
    $[4] = transactionHash;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const explorerUrl = t3;
  let t4;
  if ($[6] !== onBack || $[7] !== transactionHash) {
    t4 = () => {
      if (transactionHash) {
        FlowActions.endFlow();
      } else {
        onBack();
      }
    };
    $[6] = onBack;
    $[7] = transactionHash;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleClose = t4;
  const isSending = !error && (!isDone || isLoading || isPending);
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 1,
      scale: 1
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0,
      scale: 0.95
    };
    t7 = {
      opacity: 0,
      scale: 0.95
    };
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] !== error || $[13] !== isSending) {
    t8 = <SendingIcon error={error} isSending={isSending} />;
    $[12] = error;
    $[13] = isSending;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = isSending ? "opacity-100" : "translate-x-[25px] opacity-0";
  let t10;
  if ($[15] !== t9) {
    t10 = classNames(headingClassNames, t9);
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t("sending.sendingStatus");
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <TextHeading className={t10} size="lg">{t11}</TextHeading>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = isSending && "translate-x-[-25px] opacity-0";
  let t14;
  if ($[22] !== t13) {
    t14 = classNames(headingClassNames, t13);
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== error || $[25] !== t) {
    t15 = error ? t("sending.errorStatus") : t("sending.sentStatus");
    $[24] = error;
    $[25] = t;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t14 || $[28] !== t15) {
    t16 = <TextHeading className={t14} size="lg">{t15}</TextHeading>;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t12 || $[31] !== t16) {
    t17 = <div className="relative h-10 w-full">{t12}{t16}</div>;
    $[30] = t12;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== quantity) {
    t18 = <NumberDisplay className="font-medium text-display-lg" value={quantity} />;
    $[33] = quantity;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== currency.symbol) {
    t19 = <TextBody className="font-mono text-display-lg text-secondary">{currency.symbol}</TextBody>;
    $[35] = currency.symbol;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t18 || $[38] !== t19) {
    t20 = <Flex className="items-center gap-3">{t18}{t19}</Flex>;
    $[37] = t18;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== currency.usdPrice || $[41] !== quantity) {
    t21 = bn(quantity).times(currency.usdPrice).toString();
    $[40] = currency.usdPrice;
    $[41] = quantity;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t21) {
    t22 = <NumberDisplay className="text-text-secondary" display="usd" value={t21} />;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t20 || $[46] !== t22) {
    t23 = <FlexColumn className="items-center gap-3">{t20}{t22}</FlexColumn>;
    $[45] = t20;
    $[46] = t22;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t17 || $[49] !== t23 || $[50] !== t8) {
    t24 = <motion.div animate={t5} className="w-full" exit={t6} initial={t7}><FlexColumn className="items-center gap-5 py-16">{t8}{t17}{t23}</FlexColumn></motion.div>;
    $[48] = t17;
    $[49] = t23;
    $[50] = t8;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      translateY: "0%"
    };
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  let t27;
  let t28;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      translateY: "100%"
    };
    t27 = {
      translateY: "100%"
    };
    t28 = {
      ...transitions.default,
      duration: 1
    };
    $[53] = t26;
    $[54] = t27;
    $[55] = t28;
  } else {
    t26 = $[53];
    t27 = $[54];
    t28 = $[55];
  }
  let t29;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Flex className="-top-5 absolute w-full justify-center"><div className="rounded-full bg-bg-additional-3 p-2"><ArrowDownward size={24} /></div></Flex>;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] !== t) {
    t30 = t("sending.recipientWalletLabel");
    $[57] = t;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t30) {
    t31 = <TextLabel className="text-text-secondary" size="sm">{t30}</TextLabel>;
    $[59] = t30;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== imageUrl) {
    t32 = imageUrl && <Avatar className="rounded-full" size={64} src={imageUrl} />;
    $[61] = imageUrl;
    $[62] = t32;
  } else {
    t32 = $[62];
  }
  let t33;
  if ($[63] !== address || $[64] !== ensName) {
    t33 = ensName ? <FlexColumn className="gap-1"><TextHeading className="font-medium font-mono" size="md">{ensName}</TextHeading><TextBody className="font-mono text-secondary">{formatAddress(address)}</TextBody></FlexColumn> : <TextHeading className="font-mono font-normal" size="md">{formatAddress(address)}</TextHeading>;
    $[63] = address;
    $[64] = ensName;
    $[65] = t33;
  } else {
    t33 = $[65];
  }
  let t34;
  if ($[66] !== t32 || $[67] !== t33) {
    t34 = <FlexColumn className="items-center gap-2">{t32}{t33}</FlexColumn>;
    $[66] = t32;
    $[67] = t33;
    $[68] = t34;
  } else {
    t34 = $[68];
  }
  let t35;
  if ($[69] !== t31 || $[70] !== t34) {
    t35 = <FlexColumn className="items-center gap-6 px-9 pt-9 text-center">{t31}{t34}</FlexColumn>;
    $[69] = t31;
    $[70] = t34;
    $[71] = t35;
  } else {
    t35 = $[71];
  }
  let t36;
  if ($[72] !== error || $[73] !== explorerUrl || $[74] !== getName || $[75] !== isLoading || $[76] !== retry || $[77] !== t) {
    t36 = error ? <Button onClick={retry} size="lg" variant="destructive">{t("sending.retryButton")}</Button> : <Button className="w-full" disabled={!explorerUrl} onClick={() => {
      window.open(explorerUrl, "_blank");
    }} size="lg" variant="tertiary">{isLoading ? t("sending.confirmInWalletButton") : t("sending.viewOnExplorerButton", {
        explorerName: getName()
      })}</Button>;
    $[72] = error;
    $[73] = explorerUrl;
    $[74] = getName;
    $[75] = isLoading;
    $[76] = retry;
    $[77] = t;
    $[78] = t36;
  } else {
    t36 = $[78];
  }
  let t37;
  if ($[79] !== t) {
    t37 = t("sending.closeButton");
    $[79] = t;
    $[80] = t37;
  } else {
    t37 = $[80];
  }
  let t38;
  if ($[81] !== handleClose || $[82] !== t37) {
    t38 = <Button className="w-full" onClick={handleClose} size="lg" variant="secondary">{t37}</Button>;
    $[81] = handleClose;
    $[82] = t37;
    $[83] = t38;
  } else {
    t38 = $[83];
  }
  let t39;
  if ($[84] !== t36 || $[85] !== t38) {
    t39 = <FlexColumn className="w-full gap-4">{t36}{t38}</FlexColumn>;
    $[84] = t36;
    $[85] = t38;
    $[86] = t39;
  } else {
    t39 = $[86];
  }
  let t40;
  if ($[87] !== t) {
    t40 = t("sending.followWalletPrompt");
    $[87] = t;
    $[88] = t40;
  } else {
    t40 = $[88];
  }
  let t41;
  if ($[89] !== t40) {
    t41 = <TextBody className="font-mono text-secondary" size="xs">{t40}</TextBody>;
    $[89] = t40;
    $[90] = t41;
  } else {
    t41 = $[90];
  }
  let t42;
  if ($[91] !== t39 || $[92] !== t41) {
    t42 = <FlexColumn className="grow items-center justify-end gap-4 px-6 pb-6">{t39}{t41}</FlexColumn>;
    $[91] = t39;
    $[92] = t41;
    $[93] = t42;
  } else {
    t42 = $[93];
  }
  let t43;
  if ($[94] !== t35 || $[95] !== t42) {
    t43 = <motion.div animate={t25} className="w-full" exit={t26} initial={t27} transition={t28}><FlexColumn className="relative w-full grow gap-4 rounded-t-2xl border-border-2 border-x border-t bg-bg-additional-1">{t29}{t35}{t42}</FlexColumn></motion.div>;
    $[94] = t35;
    $[95] = t42;
    $[96] = t43;
  } else {
    t43 = $[96];
  }
  let t44;
  if ($[97] !== t24 || $[98] !== t43) {
    t44 = <AnimatePresence><FlexColumn className="h-full items-center justify-between">{t24}{t43}</FlexColumn></AnimatePresence>;
    $[97] = t24;
    $[98] = t43;
    $[99] = t44;
  } else {
    t44 = $[99];
  }
  return t44;
}
const SendingIcon = t0 => {
  const $ = _c(18);
  const {
    isSending,
    error
  } = t0;
  const t1 = error ? "bg-error-1-transparent-1" : isSending ? "bg-bg-additional-1" : "bg-success-1-transparent-1";
  let t2;
  if ($[0] !== t1) {
    t2 = classNames("size-[100px] overflow-hidden rounded-full", t1, iconClassNames, "transition-colors");
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isSending && !error ? "translate-x-0" : "translate-x-[100px]";
  let t4;
  if ($[2] !== t3) {
    t4 = classNames(t3, iconClassNames);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <Send className={t4} size={44} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== error || $[7] !== isSending) {
    t6 = error ? <Close className={classNames("fixed scale-100 text-error-1 opacity-100", iconClassNames)} size={59.88} /> : <Check className={classNames("fixed text-success-1", isSending ? "scale-0 opacity-0" : "scale-100 opacity-100", iconClassNames)} size={59.88} />;
    $[6] = error;
    $[7] = isSending;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = !isSending && "opacity-0";
  let t8;
  if ($[9] !== t7) {
    t8 = classNames("fixed size-[100px] opacity-25", t7);
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <Spinner className={t8} />;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t2 || $[14] !== t5 || $[15] !== t6 || $[16] !== t9) {
    t10 = <CenterAligned className={t2}>{t5}{t6}{t9}</CenterAligned>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};